let colorMap = {
  'darkred': '#7D170F',
  'red': '#E83324',
  'orange': '#f1A83B',
  'yellow': '#FFFE53',
  'palegreen': '#B1F8A2',
  'green': '#3A7D21',
  'deepskyblue': '#5ABDF9',
  'blue': '#0419F5',
  'darkblue': '#010885',
  'purple': '#73187B'
}
// 居中 居左 居右 转latex处理
export function handelPEleToLatex (content) {
  const reg = /<p[\s\S]*?([\s\S]*?)>([\s\S]*?)<\/p>/gi
  const realContent = content.replace(reg, ($1, $2, $3) => {
    let text = ''
    if ($2.indexOf('text-align: center;') > -1) {
      text = `\\wbcenter{${$3}}`
    } else if ($2.indexOf('text-align: right;') > -1) {
      text = `\\wbright{${$3}}`
    } else {
      text = `\\wbleft{${$3}}`
    }
    return text
  })
  if (reg.test(realContent)) {
    return handelPEleToLatex(realContent)
  } else {
    return realContent
  }
}
// 将编辑框内容html样式转化为latex编码
export function htmlToLatex (text) {
  var result = text
  // $$标签内容不做任何处理，先使用<>括起
  result = result.replace(/\$\$(\$[^$]+|[^$]*)*\$\$/g, function (match) {
    return '<' + match + '>'
  })
  // 处理文本居中居右
  result = handelPEleToLatex(result)
  // 将br替换成回车
  result = result.replace(/\<br \/\>/g, '\n')
  // 处理拼音
  result = result.replace(/<special[^>]*>([\s\S]*?)<\/special>/g, function ($1, $2) {
    return `\\wbpinyin{${$2}}`
  })
  // 去掉标签外空格、并删除非span、BIU、$$标签
  //   result = result.replace(/\s+(?![^<>]+>)/g, '');
  // 处理文本加点
  result = result.replace(/<wordpoint[^>]*>([\s\S]*?)<\/wordpoint>/g, function ($1, $2) {
    return `\\CJKunderdot{${$2}}`
  })
  result = result.replace(/<underline[^>]*>([\s\S]*?)<\/underline>/g, '\\blank{5em}')
  const reg = /<(?!\/?(span|strong|table|caption|thead|tbody|tr|td|th|em|u|\$\$))[^>]*>/gi
  result = result.replace(reg, '')
  // 删除修饰内容为空的样式
  result = result.replace(/<(?!\$\$|\/)[^>]*><\/[^>]*>/g, '')
  // 替换BIU
  result = result.replace(/<(st)[^>]*>/gi, '\\ywstriking{')
  result = result.replace(/<(e)[^>]*>/gi, '\\ywitalic{')
  result = result.replace(/<(u)[^>]*>/gi, '\\underline{')
  result = result.replace(/<\/(st|e|u)[^>]*>/gi, '}')

  // 替换style：颜色字号字体
  result = _replaceSpan(result)

  // 还原$$内容
  result = result.replace(/<(\$\$[^>]*)>/g, function (match, content) {
    return content
  })
  // 将文本框转义的html标签还原
  return _unescapeHtml(result)
}

// 将编辑框转义的html特殊字符还原
export function _unescapeHtml (val) {
  return val.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&emsp;/g, '　')
}

// 递归替换span标签内的样式
function _replaceSpan (text) {
  var result = text
  var tail = ['', '}', '}}', '}}}']
  var size = ['smaller', 'small', 'default', 'large', 'larger']
  var _fontSize = [10, 12, 16, 18]
  var styleCount = 0
  while (/<span[^>]*>(<\$\$[^>]*>|[^<])*<\/span>/.test(result)) {
    result = result.replace(/<span[^>]*>((<\$\$[^>]*>|[^<])*)<\/span>/g, function (matchStr, content) {
      styleCount = 0
      var head = ''
      // 去掉分号
      var style = matchStr.match(/[^"]*(?=">)/)
      //   var style = matchStr.match(/[^"]*(?=;">)/);
      if (style == null) {
        return content
      }
      style = style[0].split(';')
      style.forEach(function (item) {
        //  替换颜色
        for (let color in colorMap) {
          if (colorMap.hasOwnProperty(color)) {
            const value = colorMap[color]
            const reg = new RegExp(value, 'ig')
            item = item.replace(reg, color)
          }
        }
        // 下划线
        item = item.replace(/1px solid/ig, 'underline')
        item = item.replace(/inline-block/ig, '')

        item = item.split(':')

        if (item[0] == 'font-size') {
          if (_fontSize.includes(parseInt(item[1]))) {
            head += '\\yw' + size[(parseInt(item[1], 10) - 10) / 2] + '{'
          } else {
            styleCount++
          }
          // styleCount++;
        } else if (item[0] == 'color' && item[1] != 'null') {
          // if (item[1])
          head += '\\yw' + item[1] + '{'
          // styleCount++;
        } else if (item[0] == 'background-color' && item[1] != 'null') {
          head += '\\mycolorbox[' + item[1] + ']{'
        } else if (item[0] == 'border-bottom') {
          head += '\\' + item[1] + '{'
          // styleCount++;
        } else if (item[0] == 'font-family') {
          if (item[1] == 'Microsoft YaHei') item[1] = 'YaHei'
          head += '\\yw' + item[1] + '{'
          // styleCount++;
        } else {
          styleCount++
          // head += "\\yw" + item[1] + "{";
        }
      })
      return head + content + tail[style.length - styleCount]
    })
  }
  return result
}

// 将latex编码样式转化为html
export function latexToHtml (text, size, type) {
  var sizeTag = ['smaller', 'small', 'default', 'large', 'larger']
  var BIUTag = ['striking', 'italic', 'underline']
  var BIUValue = ['strong', 'em', 'u']
  var fontNameTag = ['SimSun', 'Kaiti', 'YaHei', 'SimHei', 'LiSu', 'Fangsong']
  var colorTag = ['darkred', 'red', 'orange', 'yellow', 'palegreen', 'green', 'deepskyblue', 'blue', 'darkblue', 'purple']

  var result = text
  size = (typeof size === 'undefined') ? 10 : size - 4
  type = (typeof type === 'undefined') ? 'px' : type

  // $$标签内容不做任何处理，先使用<>括起
  result = result.replace(/\$\$(\$?[^$])*\$\$/g, function (match) {
    return '<' + match + '>'
  })
  // 处理文本加点
  result = result.replace(/\\CJKunderdot{/g, '\\ywCJKunderdot{')
  // underline加上yw
  result = result.replace(/\\underline{/g, '\\ywunderline{')
  // 处理背景为yw
  result = result.replace(/\\mycolorbox\[/g, '\\ywcolorbox\[')
  // 文本居中
  result = result.replace(/\\wbcenter\{/g, '\\ywwbcenter\{')
  // 文本居右
  result = result.replace(/\\wbright\{/g, '\\ywwbright\{')
  // 文本正常
  result = result.replace(/\\wbleft\{/g, '\\ywwbleft\{')
  // 拼音
  result = result.replace(/\\wbpinyin\{/g, '\\ywwbpinyin\{')
  // 纯下划线
  result = result.replace(/\\blank\{/g, '\\ywblank\{')

  while (/\\yw[^{}]*{(<\$\$[^>]*>|\\[{}]|[^{}])*}/.test(result)) {
    result = result.replace(/\\yw([^{}]*){((<\$\$[^>]*>|\\[{}]|[^{}])*)}/g, function (matchStr, style, content) {
      var head = '', tail = ''
      var index
      if ((index = BIUTag.indexOf(style.trim())) >= 0) {
        head = '<' + BIUValue[index] + '>'
        tail = '</' + BIUValue[index] + '>'
      } else if ((index = sizeTag.indexOf(style.trim())) >= 0 && index != 2) {
        head = '<span style="font-size:' + (size + 2 * index) + type + ';">'
        tail = '</span>'
      } else if (fontNameTag.indexOf(style.trim()) >= 0) {
        head = '<span style="font-family:' + style.trim() + ';">'
        tail = '</span>'
      } else if (colorTag.indexOf(style.trim()) >= 0) {
        //  替换颜色为十六进制
        let resultColor
        for (let color in colorMap) {
          if (colorMap.hasOwnProperty(color)) {
            const value = colorMap[color]
            if (style.trim() == color) {
              resultColor = value
            }
          }
        }
        head = '<span style="color:' + resultColor + ';">'
        tail = '</span>'
      } else if (style.indexOf('colorbox') !== -1) {
        let resultColor
        for (let color in colorMap) {
          if (colorMap.hasOwnProperty(color)) {
            const value = colorMap[color]
            if (style.slice(9, style.length - 1) == color) {
              resultColor = value
            }
          }
        }
        head = '<span style="background-color:' + resultColor + ';">'
        tail = '</span>'
      } else if (style.indexOf('CJKunderdot') !== -1) {
        head = '<wordpoint>'
        tail = '</wordpoint>'
      } else if (style == 'wbcenter') {
        head = '<p style="text-align: center;">'
        tail = '</p>'
      } else if (style == 'wbright') {
        head = '<p style="text-align: right;">'
        tail = '</p>'
      } else if (style == 'wbleft') {
        head = '<p>'
        tail = '</p>'
      } else if (style == 'wbpinyin') {
        head = '<special style="font-family: pinyinFont">'
        tail = '</special>'
      } else if (style == 'blank') {
        return '<underline contenteditable="false" style="display: inline-block;width: 50px;border-bottom: 1px solid black;"> </underline>'
      } else {
        head = '<latex' + style.trim() + '>'
        tail = '</latex>'
      }
      return head + content + tail
    })
  }
  // 还原其它latex文本
  result = result.replace(/<latex([^<>]*)>/g, function (matchStr, content) {
    return '\\yw' + content + '{'
  })
  result = result.replace(/<\/latex>/g, '}')
  // 正文{}去掉转义，<$$ $$>内的不进行转化
  result = result.replace(/\\}(?!(\$?[^$])*\$\$>)/g, '}').replace(/\\{(?!(\$?[^$])*\$\$>)/g, '{')
  // 还原$$内容
  result = result.replace(/<(\$\$(\$?[^$])*\$\$)>/g, function (match, content) {
    return content
  })
  // 替换换行为br
  result = result.replace(/(\n)/gi, '<br />')
  // 去掉table后面的br
  result = result.replace(/<\/p>\<br \/\>/gi, '</p>')
  result = result.replace(/<\/table>\<br \/\>/gi, '</table>')
  return result
}

export function JsUBB (str) {
  // 粗体
  var re = /\[b\](.[^\[]*)\[\/b\]/gi
  str = str.replace(re, '<b>$1</b>')

  // 斜体字
  re = /\[i\](.[^\[]*)\[\/i\]/gi
  str = str.replace(re, '<i>$1</i>')

  // 下划线
  re = /\[u\](.[^\[]*)\[\/u\]/gi
  str = str.replace(re, '<u>$1</u>')

  // 文本下面加点
  re = /\[d\](.[^\[]*)\[\/d\]/gi
  str = str.replace(re, "<span class='typo-em'>$1</span>")

  // 文本下面加波浪线
  re = /\[w\](.[^\[]*)\[\/w\]/gi
  str = str.replace(re, "<span class='wave'>$1</span>")

  // 上标
  re = /\[sub\](.[^\[]*)\[\/sub\]/gi
  str = str.replace(re, '<sub>$1</sub>')

  // 下标
  re = /\[sup\](.[^\[]*)\[\/sup\]/gi
  str = str.replace(re, '<sup>$1</sup>')

  // 字体大小
  re = /\[size=(\d+)\](.[^\[]*)\[\/size\]/gi
  str = str.replace(re, function (s1, s2, s3) {
    return `<font size="${s2}">${s3}</font>`
    // return '<span style="font-size: ' + s2 + 'px">' + s3 + '</span>';
  })

  // 填空题中的空隔，num表示空的数量（可输入的文字数量，不区分中英文）
  re = /\[blank=(\d+)\]/gi
  str = str.replace(re, function (s1, s2) {
    var _t1 = s2 * 12
    return '<span class="test_blank" style="width:' + _t1 + 'px">&nbsp;</span>'
  })
  return str
}



// WEBPACK FOOTER //
// ./packages/material-editor/utils/latex.js